import { render, staticRenderFns } from "./Articleclass.vue?vue&type=template&id=b5171862&scoped=true"
import script from "./Articleclass.vue?vue&type=script&lang=js"
export * from "./Articleclass.vue?vue&type=script&lang=js"
import style0 from "./Articleclass.vue?vue&type=style&index=0&id=b5171862&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5171862",
  null
  
)

export default component.exports